import { DataServer } from "../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toggleLoading } from "../LoadingSlice";
import { activateSweetAlert, deActivateSweetAlert } from "../SweetAlert";
import { toast } from "react-toastify";

interface ProjectInformationState {
  ProjectInformation: {
    load: boolean;
    data: [];
  };
}

export const ProjectInformationSlice = createSlice({
  name: "ProjectInformation",
  initialState: {
    ProjectInformation: {
      load: false,
      data: [],
    },
  } as ProjectInformationState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(
        fetchProjectInformation.pending,
        (state: ProjectInformationState) => {
          state.ProjectInformation.load = true;
        }
      )
      .addCase(
        fetchProjectInformation.fulfilled,
        (state: ProjectInformationState, action: any) => {
          state.ProjectInformation.data = action.payload;
          state.ProjectInformation.load = false;
        }
      )
      .addCase(
        fetchProjectInformation.rejected,
        (state: ProjectInformationState) => {
          state.ProjectInformation.load = false;
        }
      );
  },
});

export default ProjectInformationSlice.reducer;

export const fetchProjectInformation = createAsyncThunk(
  "ProjectInformation/fetchProjectInformation",
  async (
    param: { apiParam: { project_pin: any; layout_id: any } },
    thunkAPI
  ) => {
    try {
      thunkAPI.dispatch(toggleLoading());
      const { data } = await DataServer.post("api/getProjectInformation", {
        project_pin: param.apiParam.project_pin,
        layout_id: param.apiParam.layout_id
      });
      thunkAPI.dispatch(toggleLoading());
      return data.data;
    } catch (error) {
      thunkAPI.dispatch(toggleLoading());
    }
  }
);

export const postProjectInformation = createAsyncThunk(
  "ProjectInformation/postProjectInformation",
  async (
    param: { apiParam: any; NextTab: any },
    thunkAPI
  ) => {
    try {
      const { data } = await DataServer.post("api/postProjectsInformation",  param.apiParam);

      toast.success(data.message,{theme: "colored", onClose: () => {handleonConfirm();}});

      const handleonConfirm = () => {
        param.NextTab("tab_2");
      };
      return data.data;
    } catch (error) {
      toast.error("Something went wrong!",{theme: "colored"});
    }
  }
);
